/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Statistic, StatisticLabel, StatisticValue } from 'semantic-ui-react'
import { intlFormat } from '../../../../../helpers/money'
import { CardContent } from '../../../Shared/Card'
import React from 'react'
import useUser from '../../../../Shared/UserProvider/useUser'

const NegativeActivityCardContent = ({revenuesMissed, missedOrder}) => {
    const {user} = useUser()
    return (
      <CardContent
        className='card-content'
        css={css`
            display: grid;
            place-items: center;
            gap: .5rem;
            grid-template-areas: 'a' 'b';
        `}
      >
          <>
              <Statistic
                css={css`
                    grid-area: a;

                    &.ui.statistic, &.ui.statistic + .ui.statistic {
                        margin: 0;
                    }
                `}
                color="red"
              >
                  <StatisticValue>
                      {intlFormat(revenuesMissed, user.getCompanyCurrency(), user.getCompanyLocale())}
                  </StatisticValue>
                  <StatisticLabel>
                      Chiffre d'affaire non acquis
                  </StatisticLabel>
              </Statistic>

              <Statistic
                css={css`
                    grid-area: b;

                    &.ui.statistic, &.ui.statistic + .ui.statistic {
                        margin: 0;
                    }
                `}
                size="tiny"
                color="red"
              >
                  <StatisticValue>
                      {missedOrder}
                  </StatisticValue>
                  <StatisticLabel>
                      # commandes non acquises
                  </StatisticLabel>
              </Statistic>
          </>
      </CardContent>
    )
}

export { NegativeActivityCardContent }
